import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
const StatusBadge = ({ badgeColor, statusName }) => {
    const color = badgeColor || "secondary";
    return _jsx("div", { className: `badge badge-${color}`, children: statusName });
};
export default StatusBadge;
